import { useQuery } from "react-query";
import { getLeasedEquipmentType } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";

export const useGetLeasedEquipmentType = () => {
  return useQuery("GetLeasedEquipmentType", getLeasedEquipmentType, {
    refetchOnWindowFocus: false,
  });
};
